import React from "react";
var __jsx = React.createElement;
import stl from "../../HomePage.module.css";
import LinksToSearchV2 from "../LinksToSearch/LinksToSearchV2";
import useHelpers from "@hooks/useHelpers";
import { useTranslation } from "@i18n";
export default function SearchByRangeContainer(props) {
  var _useTranslation = useTranslation(["web_home"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _props$data = props.data,
    price_ranges = _props$data.price_ranges,
    odometer_ranges = _props$data.odometer_ranges;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "px-8 mx-auto text-[#154F9C] text-lg font-bold leading-[32px] md:text-xl "
  }, /*#__PURE__*/React.createElement("div", {
    className: "border-t border-t-[#E2E2E2] border-solid rounded-[2px] mt-4 mb-4"
  }), t("تصفح السيارات حسب السعر أو الممشى", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("div", {
    className: ["m-show", stl.CustomContainer, stl.undoCustomWidth].join(" ")
  }, /*#__PURE__*/React.createElement(LinksToSearchV2, {
    moreLink: createUrl("/filters", {
      sort: "price"
    }),
    range: true,
    bgColor: "#EFF6FF",
    data: price_ranges,
    fieldName: "price",
    linkValue: "value",
    fromField: "from",
    toField: "to",
    isNew: props.isNew,
    isPrice: true
  })), !props.isNew && /*#__PURE__*/React.createElement("div", {
    className: ["m-show", stl.CustomContainer, stl.undoCustomWidth].join(" ")
  }, /*#__PURE__*/React.createElement(LinksToSearchV2, {
    moreLink: createUrl("/filters", {
      sort: "milage"
    }),
    bgColor: "#FCEDE3",
    data: odometer_ranges,
    fieldName: "range",
    linkValue: "id",
    isNew: props.isNew,
    range: true
  })));
}